export default "__VITE_ASSET__DFZKwKiZ__"